// Route guard for the supplier pages: the feature phase (PD-2), on top of the permission
// guard App.js puts around it (specs/20260930-leveranciers-tickets-interventies, T117).
//
// PermissionRoute answers "may this user?"; this answers "is the feature on?". admin and
// super_admin pass every permission check, so without this they would land on a page whose
// every API call answers 404 while SUPPLIERS_ENABLED is off.

import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useSupplierFeature from '../../hooks/useSupplierFeature';

const SupplierFeatureRoute = ({ minPhase = 1, fallbackPath = '/dashboard' }) => {
  const { phase, loading } = useSupplierFeature();
  // Same as PermissionRoute: render nothing until the answer is in, rather than bouncing an
  // entitled user away on the first paint.
  if (loading) return null;
  return phase >= minPhase ? <Outlet /> : <Navigate to={fallbackPath} replace />;
};

export default SupplierFeatureRoute;
